import { HIDE_CONFIRM, ON_CONFIRM, SHOW_CONFIRM } from "./actionType";

export const setShowConfirmToState = payload => ({
    type: SHOW_CONFIRM,
    payload,
});
export const actionConfirmToState = payload => ({
    type: ON_CONFIRM,
    payload,
});
export const setHideConfirmToState = () => ({
    type: HIDE_CONFIRM,
});

export const showConfirm = (message, onConfirm) => {
    return dispatch => {
        dispatch(setShowConfirmToState({ message, onConfirm }));
    };
};
export const hideConfirm = () => {
    return dispatch => {
        dispatch(setHideConfirmToState());
    };
};